import React, { useState } from 'react';
import {
    LevelDropdownContainer,
    ProcedureLevel,
    SubTitle,
} from './levelProcedure.styled';
import { Box, Button, Divider, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useWindowSize from '../getWindowSize';
import { sizes } from 'src/styles/Media.styled';
import Select from '../form/select/Select';
import {
    getModifiedErrorLevelsSelection,
    getModifiedFirstLevelsSelection,
    getModifiedLevelsSelection,
   
} from 'src/pages/reportUsage/procedure/dataTransformationUtil';
import { useDispatch, useSelector } from 'react-redux';
import {
    checkIsErrorFoundInFirstLevel,
    checkIsErrorFoundInProcedureLevel,
    checkIsFirstLevelSelected,
    setIsFirstLivSelected,
    setIsFirstUivSelected,
    setLivDropdownValue,
    
    setModifiedLevelDataFlag,
    setProcedureData,
    
    setTotalLevelsNumber,
    setUivDropdownValue,
   
} from 'src/pages/reportUsage/redux/action/actionCreators';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import { DeleteButtonContainer } from 'src/pages/reportUsage/record/components/reportPayment/ItemList/ReportPaymentItemListMobile/LotSerialRPQtyInputMobile';
import { SMALL_TEXT_PX, X_SMALL_TEXT_PX } from '../../../styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const AddProcedureLevel = ({
    
    deleteItem,
    levelsData,
    uivDropdownValue,
    livDropdownValue,
    isFirstUivSelected,
    isFirstLivSelected,
    isUivSelected,
    setIsUivSelected,
    setIsLivSelected,
    errorEachLevelMsg,
    errorMsg,
    setErrorEachLevelMsg,
    informationaLevellMsg,
    
    // errorFirstLevelMsg,
    // setErrorFirstLevelMsg,
    uivState,
    livState,
    setUivState,
    setLivState,
    setEachUivCount,
    setEachLivCount,
    setUivCount,
    setLivCount,
    procedureLevels,
    currentId,
    isFoundDuplicate,
    procedureInfoData,
    setProcedureInfoData,
    updateEachErrorState,
    uivStateFromDraft,
    livStateFromDraft,
    isFromDraft,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [winWidth] = useWindowSize();
    const isDesktopView = winWidth > sizes.ipadAir;
    const isMobileView = winWidth < sizes.smalDevice;
    const isTabletView =
        winWidth >= sizes.smalDevice && winWidth <= sizes.ipadAir;

    const [informationMsg, setInformationMsg] = useState('');
    const [currRowId, setCurrRowId] = useState(0);
    const [errorFirstLevelMsg, setErrorFirstLevelMsg] = React.useState('');

    const uivArray = useSelector(
        (state) => state.reportUsageRootReducer.uivArray
    );
    const livArray = useSelector(
        (state) => state.reportUsageRootReducer.livArray
    );
    const totalLevelsNumber = useSelector(
        (state) => state.reportUsageRootReducer.totalLevelsNumber
    );
    // const levelsDataNew = useSelector(
    //     (state) => state.reportUsageRootReducer.procedureData.levelsData
    // );
    const isErrorFoundInFirstLevel = useSelector(
        (state) => state.reportUsageRootReducer.isErrorFoundInFirstLevel
    );
    const isErrorFoundInProcedure = useSelector(
        (state) => state.reportUsageRootReducer.isErrorFoundInProcedure
    );

    const handleLevelsDropdownChange = (value, stateKey, id) => {

        if (!value || value.length === 0) {
            if (stateKey === 'uivState') {
                if (uivDropdownValue) {
                    dispatch(setUivDropdownValue([]));
                    dispatch(setIsFirstUivSelected(false));
                } else if (uivState) {
                    setUivState('');
                    setIsUivSelected(false);
                }
            } else if (stateKey === 'livState') {
                if (livDropdownValue) {
                    dispatch(setLivDropdownValue([]));
                    dispatch(setIsFirstLivSelected(false));
                } else if (livState) {
                    setLivState('');
                    setIsLivSelected(false);
                }
            }
            return;
        } else {
            const selectedCode = value.code;
            const selectedLevel = levelsData.find(
                (level) => level.code.toString() === selectedCode
            );
            if (selectedLevel && stateKey === 'uivState') {
                const selectedLevelRow = procedureLevels?.filter(
                    (level) => level.id === id
                );
                if (selectedLevelRow?.length > 0) {
                    selectedLevelRow[0].uivDropdown.uivState = value;
                    setUivState(value);
                    setIsUivSelected(true);
                    setCurrRowId(id);
                } else {
                    // setCurrRowId(0);
                    dispatch(setUivDropdownValue(value));
                    dispatch(setModifiedLevelDataFlag(true));
                    dispatch(setIsFirstUivSelected(true));
                    // dispatch(setUivFirstLevelSelected(value));
                }
            } else if (selectedLevel && stateKey === 'livState') {
                const selectedLevelRow = procedureLevels?.filter(
                    (level) => level.id === id
                );
                if (selectedLevelRow?.length > 0) {
                    selectedLevelRow[0].livDropdown.livState = value;
                    setLivState(value);
                    setIsLivSelected(true);
                    setCurrRowId(id);
                } else {
                    // setCurrRowId(0);
                    dispatch(setLivDropdownValue(value));
                    dispatch(setModifiedLevelDataFlag(true));
                    dispatch(setIsFirstLivSelected(true));
                    // dispatch(setLivFirstLevelSelected(value));
                }
            }
 
        }
    };

    useEffectWithErrorLogging(() => {
        if (!uivDropdownValue?.code && !livDropdownValue?.code) {
            updateEachErrorState();
            setErrorFirstLevelMsg('');
            setInformationMsg('');
            dispatch(checkIsFirstLevelSelected(false));
            dispatch(checkIsErrorFoundInFirstLevel(true));
            let modifiedData = [];
            modifiedData = getModifiedFirstLevelsSelection(
                levelsData,
                uivDropdownValue?.code,
                livDropdownValue?.code,
                uivDropdownValue?.description,
                isFirstUivSelected,
                isFirstLivSelected
            );
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    levelsData: modifiedData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                levelsData: modifiedData,
            }));
        } else {
            updateEachErrorState();
            setErrorFirstLevelMsg('');
            setInformationMsg('');
            dispatch(checkIsFirstLevelSelected(false));
        }
    }, []);
    useEffectWithErrorLogging(() => {
        if (
            (!uivDropdownValue?.code && livDropdownValue?.code) ||
            (uivDropdownValue?.code && !livDropdownValue?.code)
        ) {
            dispatch(checkIsFirstLevelSelected(true));
            dispatch(checkIsErrorFoundInFirstLevel(true));
        }
    }, [uivDropdownValue, livDropdownValue, uivState?.code, livState?.code]);

    useEffectWithErrorLogging(() => {
        if (uivDropdownValue?.code > 0 && livDropdownValue?.code > 0) {
            setUivCount(uivDropdownValue?.code);
            setLivCount(livDropdownValue?.code);
            dispatch(checkIsFirstLevelSelected(true));
            if (errorFirstLevelMsg) {
                dispatch(checkIsFirstLevelSelected(false));
                dispatch(checkIsErrorFoundInFirstLevel(true));
            } else {
                dispatch(checkIsFirstLevelSelected(true));
                dispatch(checkIsErrorFoundInFirstLevel(false));
            }
            if (uivDropdownValue?.code > livDropdownValue?.code) {
                updateEachErrorState();
                setErrorFirstLevelMsg('UIV must be at or above LIV level');
                setInformationMsg('');
                // setFirstLevelErrorMsg('');
                let modifiedErrorData = [];
                modifiedErrorData = getModifiedErrorLevelsSelection(
                    levelsData,
                    errorFirstLevelMsg,
                    uivDropdownValue?.code,
                    livDropdownValue?.code,
                    procedureLevels
                ); 
                dispatch(
                    setProcedureData({
                        ...procedureInfoData,
                        levelsData: modifiedErrorData,
                    })
                );
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    levelsData: modifiedErrorData,
                }));
            } else if (uivDropdownValue?.code === livDropdownValue?.code) { 
                setInformationMsg(
                    'No motion segment levels involved in procedure'
                );
                dispatch(checkIsErrorFoundInFirstLevel(false));
                updateEachErrorState();
                setErrorFirstLevelMsg('');
            } else if (uivDropdownValue?.code < livDropdownValue?.code) {
                dispatch(checkIsErrorFoundInFirstLevel(false));
                updateEachErrorState();
                setErrorFirstLevelMsg('');
                setInformationMsg('');
            }
        } else if (
            (!uivDropdownValue?.code && livDropdownValue?.code) ||
            (uivDropdownValue?.code && !livDropdownValue?.code)
        ) {
            updateEachErrorState();
            setErrorFirstLevelMsg('');
            setInformationMsg('');
            dispatch(checkIsErrorFoundInFirstLevel(true));
            dispatch(checkIsFirstLevelSelected(false)); 
        }
    }, [
        uivDropdownValue,
        livDropdownValue,
        procedureLevels,
        errorFirstLevelMsg,
        isErrorFoundInFirstLevel,
    ]);

    useEffectWithErrorLogging(() => {
        if (
            isFromDraft
                ? uivState && livState
                : uivState?.code > 0 && livState?.code > 0
        ) {
            setEachUivCount(
                isFromDraft ? uivStateFromDraft?.code : uivState?.code
            );
            setEachLivCount(
                isFromDraft ? livStateFromDraft?.code : livState?.code
            ); 
            const isErrorFound = procedureLevels?.some(
                (level) => level.error !== '' && level.error !== undefined
            ); 
            if (isErrorFound) {
                dispatch(checkIsErrorFoundInProcedureLevel(true));
            } else {
                dispatch(checkIsErrorFoundInProcedureLevel(false));
            }
            if (uivState?.code > livState?.code) {
                setErrorEachLevelMsg('UIV must be at or above LIV level');
                setInformationMsg('');
                let modifiedErrorData = [];
                modifiedErrorData = getModifiedErrorLevelsSelection(
                    levelsData,
                    errorEachLevelMsg,
                    uivState?.code,
                    livState?.code,
                    procedureLevels
                ); 
                dispatch(
                    setProcedureData({
                        ...procedureInfoData,
                        levelsData: modifiedErrorData,
                    })
                );
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    levelsData: modifiedErrorData,
                }));
            } else if (isFoundDuplicate) {
                setErrorEachLevelMsg('Same levels already entered above.');
                setInformationMsg('');
                let modifiedErrorData = [];
                modifiedErrorData = getModifiedErrorLevelsSelection(
                    levelsData,
                    errorMsg,
                    uivState?.code,
                    livState?.code,
                    procedureLevels
                ); 
                dispatch(
                    setProcedureData({
                        ...procedureInfoData,
                        levelsData: modifiedErrorData,
                    })
                );
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    levelsData: modifiedErrorData,
                }));
            } else if (uivState?.code < livState?.code) {
                updateEachErrorState();
            } else if (
                (uivState?.code === livState?.code && !errorEachLevelMsg) ||
                errorEachLevelMsg.length <= 0 ||
                errorEachLevelMsg === 'UIV must be at or above LIV level'
            ) {
                setErrorEachLevelMsg('');
                setInformationMsg('');
                
                let modifiedUivData = [];
                modifiedUivData = getModifiedLevelsSelection(
                    levelsData,
                    uivState?.code,
                    livState?.code
                );
                dispatch(
                    setProcedureData({
                        ...procedureInfoData,
                        levelsData: modifiedUivData,
                    })
                );
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    levelsData: modifiedUivData,
                }));
                let modifiedLivData = [];
                modifiedLivData = getModifiedLevelsSelection(
                    levelsData,
                    livState?.code,
                    uivState?.code
                );
                dispatch(
                    setProcedureData({
                        ...procedureInfoData,
                        levelsData: modifiedLivData,
                    })
                );
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    levelsData: modifiedLivData,
                }));
            }
            setErrorEachLevelMsg('');
            let modifiedData = [];
            modifiedData = getModifiedLevelsSelection(
                levelsData,
                livState?.code,
                uivState?.code
            );
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    levelsData: modifiedData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                levelsData: modifiedData,
            }));
        } else if (
            uivState?.length === 0 ||
            livState?.length === 0 ||
            (uivState?.length && !livState?.length) ||
            (livState?.length && !uivState?.length) ||
            (uivState?.code && !livState?.code) ||
            (!uivState?.code && livState?.code)
        ) {
            setInformationMsg('');
            setErrorEachLevelMsg('');
            dispatch(checkIsErrorFoundInProcedureLevel(true));
        }
    }, [
        uivState,
        livState,
        isFoundDuplicate,
        errorEachLevelMsg,
        informationaLevellMsg,
        isErrorFoundInProcedure,
    ]);

    useEffectWithErrorLogging(() => {
        // Calculate the total number of levels
        // For each pair, count levels from UIV to LIV inclusive, then sum all pairs
        const safeLivArray = Array.isArray(livArray) ? livArray : [];
        const safeUivArray = Array.isArray(uivArray) ? uivArray : [];

        const sumOfDifferences = safeLivArray.reduce((sum, livValue, index) => {
            const uivValue = safeUivArray[index] || 0;
            const livNum = parseInt(livValue, 10) || 0;
            const uivNum = parseInt(uivValue, 10) || 0;
            return sum + (livNum - uivNum);
        }, 0);
        dispatch(setTotalLevelsNumber(sumOfDifferences));
    }, [uivArray, livArray, dispatch]);
 

    const deleteBtnWidth = '32px !important';
    const deleteBtnHeight = '34px !important';

    const deleteBtn = (
        <Box
            component={Button}
            aria-controls="simple-menu-1"
            aria-hospopup="true"
            size="small"
            width={deleteBtnWidth}
            height={deleteBtnHeight}
            minWidth={deleteBtnWidth}
            minHeight={deleteBtnHeight}
            border="1px solid #EBEBEB"
            borderRadius={6}
            onClick={deleteItem}
        >
            <img src={DeleteLight} height={21} width={21} />
        </Box>
    );

    return (
        <>
            <ProcedureLevel
                style={
                    isMobileView
                        ? { marginLeft: '30px' }
                        : isTabletView
                        ? { marginLeft: '90px' }
                        : isDesktopView && { marginLeft: '130px' }
                }
            >
                <Grid
                    container
                    style={
                        isMobileView
                            ? { flexWrap: 'wrap' }
                            : { flexWrap: 'nowrap' }
                    }
                >
                    <Grid item>
                        <LevelDropdownContainer>
                            <Select
                                style={{
                                    width:
                                        // winWidth <= sizes.mobileDevice
                                        //         ? '100%'
                                        '105px',
                                    height: '35px',
                                    border: '1.5px solid rgb(0, 0, 0, 0.22)',
                                }}
                                id={'uivDropdown'}
                                value={uivState || uivDropdownValue}
                                options={levelsData ? levelsData : []}
                                onChange={(value) =>
                                    handleLevelsDropdownChange(
                                        value,
                                        'uivState',
                                        currentId
                                    )
                                }
                                placeholder={t('common.selectLevel')}
                                // editable={true}
                                optionLabel="description"
                            />
                        </LevelDropdownContainer>
                    </Grid>
                    <Grid item style={{ marginLeft: '15px' }}>
                        <LevelDropdownContainer>
                            <Select
                                style={{
                                    width:
                                        // winWidth <= sizes.mobileDevice
                                        //         ? '100%'
                                        '105px',
                                    height: '35px',
                                    border: '1.5px solid rgb(0, 0, 0, 0.22)',
                                }}
                                id={'livDropdown'}
                                value={livState || livDropdownValue}
                                options={levelsData ? levelsData : []}
                                onChange={(value) =>
                                    handleLevelsDropdownChange(
                                        value,
                                        'livState',
                                        currentId
                                    )
                                }
                                placeholder={t('common.selectLevel')}
                                // editable={true}
                                optionLabel="description"
                            />
                        </LevelDropdownContainer>
                    </Grid>
                    {deleteItem && (
                        <Grid item style={{ marginLeft: '23px' }}>
                            <DeleteButtonContainer
                                gridColumns={'2/-1'}
                                display={'flex'}
                                justifyContent={'flex-end'}
                                marginTop={'0px'}
                            >
                                {deleteBtn}
                            </DeleteButtonContainer>
                        </Grid>
                    )}
                    {(errorFirstLevelMsg || errorEachLevelMsg) && (
                        <Grid
                            item
                            style={{
                                display: 'flex',
                                marginLeft: deleteItem
                                    ? isMobileView
                                        ? '0px'
                                        : '31px'
                                    : isMobileView
                                    ? '0px'
                                    : '85px',
                                alignItems: 'center',
                            }}
                        >
                            <AlertMsg
                                fontSize={SMALL_TEXT_PX}
                                message={
                                    errorFirstLevelMsg || errorEachLevelMsg
                                }
                                mbHeight={'16px'}
                                mbWidth={'16px'}
                                padding={'3px 0px 0px 0px'}
                                width={
                                    deleteItem
                                        ? '0px 0px 8px 37px'
                                        : '0px 0px 8px 93px'
                                }
                                alignItems={'center'}
                            />
                        </Grid>
                    )}
                    {informationaLevellMsg || informationMsg
                        ? isMobileView && (
                              <Grid item style={{ display: 'flex' }}>
                                  <SubTitle
                                      fontSize={X_SMALL_TEXT_PX}
                                      padding={'3px 0px 0px 0px'}
                                      margin={'0px 0 8px 0px'}
                                  >
                                      {informationaLevellMsg || informationMsg}
                                  </SubTitle>
                              </Grid>
                          )
                        : null}
                    {informationaLevellMsg || informationMsg
                        ? isDesktopView && (
                              <Grid item style={{ marginLeft: '15px' }}>
                                  <SubTitle
                                      fontSize={X_SMALL_TEXT_PX}
                                      padding={'3px 0px 0px 0px'}
                                      //   paddingTop={'5px'}
                                      margin={
                                          deleteItem
                                              ? '8px 0px 8px 38px'
                                              : '8px 0px 8px 93px'
                                      }
                                  >
                                      {informationaLevellMsg || informationMsg}
                                  </SubTitle>
                              </Grid>
                          )
                        : null}
                    {informationaLevellMsg || informationMsg
                        ? isTabletView && (
                              <Grid
                                  item
                                  style={{ margin: '0px 0px 1.5px 20px' }}
                              >
                                  <SubTitle
                                      fontSize={X_SMALL_TEXT_PX}
                                      padding={'3px 0px 0px 0px'}
                                      //   paddingTop={'5px'}
                                      margin={
                                          deleteItem
                                              ? '8px 0 8px 30px'
                                              : '8px 0 8px 80px'
                                      }
                                  >
                                      {informationaLevellMsg || informationMsg}
                                  </SubTitle>
                              </Grid>
                          )
                        : null}
                </Grid>
            </ProcedureLevel>
            {isDesktopView && (
                <Grid lg={12} style={{ margin: '12px 0px 12px 22px' }}>
                    <Divider
                        style={{
                            width: '774px',
                            height: '2px',
                            color: 'rgba(0, 0, 0, 0.22)',
                        }}
                    />
                </Grid>
            )}
            {isMobileView && (
                <Grid xs={12} style={{ margin: '12px 22px 12px 22px' }}>
                    <Divider
                        style={{
                            width: 'auto',
                            height: '2px',
                            color: 'rgba(0, 0, 0, 0.22)',
                        }}
                    />
                </Grid>
            )}
            {isTabletView && (
                <Grid md={12} style={{ margin: '12px 20px 12px 22px' }}>
                    <Divider
                        style={{ height: '2px', color: 'rgba(0, 0, 0, 0.22)' }}
                    />
                </Grid>
            )}
        </>
    );
};

export default AddProcedureLevel;
